{
	"email": {
		"description": "L'indirizzo è gestito dall'organizzazione e non è modificabile qui.",
		"label": "Email",
		"title": "Email"
	},
	"load_error": {
		"description": "Non riusciamo a caricare il profilo in questo momento.",
		"title": "Profilo non disponibile"
	},
	"page_title": "Profilo",
	"password": {
		"change": "Cambia",
		"hidden": "Password impostata",
		"last_changed": "Ultima modifica {{when}}.",
		"never_changed": "Nessuna modifica registrata",
		"title": "Password"
	},
	"photo_name": {
		"description": "Come appari alle persone con cui condividi.",
		"invalid_type": "Scegli un'immagine JPEG, PNG o WebP.",
		"name_label": "Nome visualizzato",
		"name_saved": "Nome aggiornato.",
		"remove_photo": "Rimuovi",
		"removing": "Rimozione della foto…",
		"save": "Salva",
		"saving": "Salvataggio…",
		"title": "Foto e nome",
		"too_large": "Scegli un'immagine più piccola di {{size}} MB.",
		"upload_error": "Non è stato possibile caricare la foto.",
		"upload_photo": "Carica foto",
		"uploading": "Caricamento della foto…"
	},
	"redirecting": "Apertura della pagina di accesso…",
	"remove_dialog": {
		"cancel": "Annulla",
		"confirm": "Rimuovi",
		"description": "«{{name}}» non genererà più codici validi per accedere. Gli altri dispositivi continueranno a funzionare.",
		"last_confirm": "Disattiva",
		"last_description": "Per accedere basterà la password. L'app di autenticazione e i codici di recupero smetteranno di funzionare.",
		"last_title": "Disattivare la verifica in due passaggi?",
		"title": "Rimuovere questo dispositivo?"
	},
	"result": {
		"cancelled": "Operazione annullata: non è cambiato nulla.",
		"error": "Non è stato possibile completare l'operazione. Riprova.",
		"success": {
			"configure_otp": "Dispositivo aggiunto.",
			"regenerate_recovery_codes": "Nuovi codici di recupero pronti.",
			"remove_otp_device": "Dispositivo rimosso.",
			"update_password": "Password aggiornata."
		}
	},
	"retry": "Riprova",
	"two_factor": {
		"active": "Attiva",
		"add_device": "Aggiungi dispositivo",
		"codes_generate": "Genera",
		"codes_none_hint": "Se perdi il telefono non potrai accedere. Generane di nuovi.",
		"codes_none_title": "Nessun codice di recupero",
		"codes_regenerate": "Rigenera",
		"codes_remaining_one": "{{count}} rimasto · per accedere se perdi il telefono",
		"codes_remaining_other": "{{count}} rimasti · per accedere se perdi il telefono",
		"codes_title": "Codici di recupero",
		"description": "Richiesta a ogni accesso da un dispositivo nuovo.",
		"device_configured": "Configurata il {{date}}",
		"device_default_name": "App di autenticazione",
		"enable": "Attiva",
		"error_description": "Non riusciamo a leggere lo stato della verifica in due passaggi. Il tuo account non è cambiato.",
		"error_title": "Stato non disponibile",
		"inactive": "Non attiva",
		"remove_device": "Rimuovi",
		"remove_device_label": "Rimuovi {{name}}",
		"setup_hint": "Google Authenticator, Microsoft Authenticator o simili",
		"setup_title": "Usa un'app di autenticazione",
		"title": "Verifica in due passaggi"
	}
}
